import {Component, OnInit} from '@angular/core';
import {AppComponent} from "../app.component";
import {Evento} from "../eventos/evento";
import {MAX_TAM_ARQ, URL_API} from './../constante';

@Component({
    selector: 'app-evento',
    templateUrl: './evento.component.html',
    styleUrls: ['./evento.component.css']
})
export class EventoComponent extends AppComponent implements OnInit {

    evento: Evento;

    ngOnInit() {
		if (!this.isAdmin())
            this.router.navigateByUrl('inicio');
        this.evento = new Evento();
    }

    onSubmit() {
		if (new Date(this.evento.datainicio) >= new Date(this.evento.datalimit)) {
			this.utils.exibirMensagem('A data de início deve ser anterior à data limite.', 'warning');
			return null;
		}
		
		this.evento.datalimitsub = this.evento.datalimit;
	
		if (this.evento.imagem && this.evento.imagem.size > MAX_TAM_ARQ) {
			this.utils.exibirMensagem('O tamanho do arquivo têm que ser menor do que 10 Mb.', 'danger');
			return null;
		} 
		this.spinnerService.show();
        this.eventoService.save(this.evento)
            .then(() => this.goBack());
    }

    delete(id){
        this.eventoService.delete(id)
            .then(() => this.goBack());

    }
	
	fazer_upload(event: any): void {
		this.evento.imagem = event.target.files[0];
	}
	
	link_imagem(): string {
		return URL_API + '/imagem/imagem/' + this.evento.id;
    }

}



// WEBPACK FOOTER //
// ./src/app/evento/evento.component.ts